import {PartnerRepositoryType} from "./interfaces/PartnerRepositoryType.ts";
import { db } from '../firebase'
import {doc, getDoc} from "firebase/firestore";
import {Partner} from "../domain/entities/Partner.ts";
import {getAgencyAssetUrl} from "../utils/AssetsCDN.ts";

export class PartnerRepository implements PartnerRepositoryType {
    whoAmI(role: string, partnerId: string) : Promise<Partner | null> {
        //admin users aren't backed by an agency/tourOperator document; agency reads from agencies, everything else from tourOperators
        return new Promise((resolve, reject) => {
            if (role === 'admin') {
                resolve({
                    id: partnerId,
                    name: '51trips',
                    role: 'admin'
                })
            } else if (role === 'agency') {
                getDoc(doc(db, 'agencies', partnerId)).then((doc) => {
                    if (doc.exists()) {
                        const data = doc.data()
                        resolve( {
                            id: doc.id,
                            name: data.name,
                            role: "agency",
                            corporateLogo: getAgencyAssetUrl(data.logoName),
                            corporateColor: data.color?.hex

                        })
                    } else {
                        reject(null)
                    }
                })
            } else {
                getDoc(doc(db, 'tourOperators', partnerId)).then((doc) => {
                    if (doc.exists()) {
                        const data = doc.data()
                        resolve( {
                            id: doc.id,
                            name: data.shortName,
                            role,
                            corporateLogo: data.logoUrl,
                            corporateColor: data.colorCode
                        })
                    } else {
                        reject(null)
                    }
                }).catch((error) => {
                    console.error("error", error)
                    reject(error)
                })
            }
        })
    }
}
